import openSocket from "socket.io-client";
import { getBackendUrl } from "../config";
import api from "./api";

const MAX_TOKEN_RETRIES = 3;

const currentToken = () => JSON.parse(localStorage.getItem("token"));

function connectToSocket() {
    const socket = openSocket(getBackendUrl(), {
      transports: ["websocket", "polling", "flashsocket"],
      query: {
        token: currentToken(),
      },
    });

    // O servidor derruba conexões com token vencido e o cliente não tenta de
    // novo sozinho: renova o token e reconecta
    let retries = 0;
    socket.on("connect", () => {
      retries = 0;
    });
    socket.on("disconnect", async (reason) => {
      if (reason !== "io server disconnect" || retries >= MAX_TOKEN_RETRIES) {
        return;
      }
      retries += 1;
      try {
        const { data } = await api.post("/auth/refresh_token");
        localStorage.setItem("token", JSON.stringify(data.token));
        socket.io.opts.query = { token: data.token };
        socket.connect();
      } catch (err) {
        // Sessão encerrada: o fluxo de login normal assume daqui
      }
    });

    return socket;
}

export default connectToSocket;
